import { BaseDto } from './base.dto';
import type { PurchaseOrderInvoiceItemDto } from './purchasing/purchase-order-invoice-item.dto';
import { RecipeDto } from './recipe.dto';
import { StockDto } from './stock.dto';
import { StockUnitDto } from './stockUnit.dto';
import { SupplierDto } from './supplier.dto';
import {
  StockMerchantPurchasingDetailsDto
} from './stock-merchant-purchasing-details/stock-merchant-purchasing-details.dto';

export enum ParLevelIndicator {
  WARNING,
  SUCCESS,
  ERROR
}
export class PurchaseOrderItemDto extends BaseDto {
    purchaseOrderId: number;
    itemId:number;
    itemName:string;
    itemSize:string;
    stock: StockDto;
    bulkRecipe: RecipeDto;
    orderedQuantity: number;
    receivedQuantity: number;
    note: string;
    supplier: SupplierDto;
    code: string;

    stockId: number;
    bulkRecipeId: number;
    
    itemDRSValue?: number;
    stockCaseQuantity?: number;
    itemPrice?: number;
    originalItemPrice?: number;
    //contains the same information than itemPrice requested the 11/09/2023
    stockPrice?: number;
    stockUnitId?: number;
    stockUnit: StockUnitDto;
  
    deliveredSize?: string;
    vat?: number;
    gross?: number;
    net?: number;

    vatRateId?:number;

    action?:string;
    disable?: boolean;

    purchaseOrderCreditNoteId: number;
    dateProcessed?: string;
    // check if it was changed
    changed: boolean;
    editing: boolean;
    
    creditDoc?: string;
    descriptionDoc?: string;
    // object where we save temporally the information needed to calculate the current stock
    stockLevelDetail: any;
    currentStock?: number

    // assing the proper par
    minPar?: number;
    maxPar?: number;
    parLevelIndicator?: ParLevelIndicator;

    // to use with transfers
    orderedCases?: number;
    receivedCases?: number;

    orderedUnits?: number;
    receivedUnits?: number;
    
    // for invoice
    purchaseOrderInvoiceItem?: PurchaseOrderInvoiceItemDto;

    drsValue?: number; // temporary value to display the total DRS value

    stockMerchantPurchasingDetails?: StockMerchantPurchasingDetailsDto;


  //Moving the calculation of unitsPerSize for helping visbility and standarize the calculation
  public unitsPerSize?(){
    if(this.stock) return this.stock.caseSize/this.stock.unitSize;
    else if(this.bulkRecipe) return this.bulkRecipe.recipeSize/this.bulkRecipe.recipeCost;
    else return 1;
  }

    constructor(
    purchaseOrderId: number,
    purchaseOrderCreditNoteId: number,
    stock: StockDto,
    bulkRecipe: RecipeDto,
    orderedQuantity: number,
    receivedQuantity: number,
    note: string,
    deliveredSize?: string,
    vat?: number,
    ) {
      super();
      this.purchaseOrderId = purchaseOrderId;
      this.purchaseOrderCreditNoteId = purchaseOrderCreditNoteId;
      this.stock = stock;
      this.bulkRecipe = bulkRecipe;
      this.orderedQuantity = orderedQuantity;
      this.receivedQuantity = receivedQuantity;
      this.note = note;
      this.changed = true;
      this.vat = vat;
      this.deliveredSize = deliveredSize;
    }
  }